import { render, staticRenderFns } from "./AllotmentSettingTable.vue?vue&type=template&id=3f948a03&scoped=true&"
import script from "./AllotmentSettingTable.vue?vue&type=script&lang=js&"
export * from "./AllotmentSettingTable.vue?vue&type=script&lang=js&"
import style0 from "./AllotmentSettingTable.vue?vue&type=style&index=0&id=3f948a03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f948a03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VIcon,VSimpleTable,VSwitch,VTab,VTabs,VTextField})
